export const campaignConfigSettingKeys = {
    all: ['smr-admin', 'campaign'] as const,
    settings: (campaignId: string) => [...campaignConfigSettingKeys.all, campaignId, 'config-settings'] as const,
};
